import { render } from "./LoadingSpinnerNr2.vue?vue&type=template&id=f31aaccc&scoped=true"
import script from "./LoadingSpinnerNr2.vue?vue&type=script&lang=js"
export * from "./LoadingSpinnerNr2.vue?vue&type=script&lang=js"

import "./LoadingSpinnerNr2.vue?vue&type=style&index=0&id=f31aaccc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f31aaccc"]])

export default __exports__